class VCSafeComplementary extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';
    this.load(this.dataset.url, true);
  }

  async load(url, allowFallback) {
    if (!url) return this.remove();
    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      const products = (data.products || []).filter(product => product.available).slice(0, 3);
      if (!products.length && allowFallback && this.dataset.fallbackUrl) return this.load(this.dataset.fallbackUrl, false);
      if (!products.length) return this.remove();
      this.renderProducts(products);
    } catch (_) {
      if (allowFallback && this.dataset.fallbackUrl) return this.load(this.dataset.fallbackUrl, false);
      this.remove();
    }
  }

  renderProducts(products) {
    const heading = this.dataset.heading || '';
    this.innerHTML = `<div class="vc-safe-complementary" data-vc-complementary-content><div class="vc-safe-complementary__header"><p class="vc-safe-complementary__heading">${this.escape(heading)}</p></div><div class="vc-safe-complementary__list">${products.map(product => this.card(product)).join('')}</div></div>`;
  }

  card(product) {
    const variant = (product.variants || []).find(v => v.available) || product.variants?.[0];
    const direct = variant && (product.variants || []).length === 1;
    const image = product.featured_image || product.images?.[0] || '';
    const title = this.escape((product.title || '').length > 44 ? `${product.title.slice(0, 43)}…` : product.title || '');
    const price = this.money(variant?.price ?? product.price ?? 0);
    const action = direct
      ? `<button type="button" class="vc-safe-complementary__button" data-vc-complementary-add data-variant-id="${variant.id}" aria-label="${this.escape(this.dataset.addLabel || 'Add')}: ${title}"><span aria-hidden="true">+</span></button>`
      : `<a class="vc-safe-complementary__button vc-safe-complementary__button--link" href="${product.url}" aria-label="${this.escape(this.dataset.optionsLabel || 'Options')}: ${title}"><span aria-hidden="true">→</span></a>`;
    return `<div class="vc-safe-complementary__item"><a href="${product.url}" class="vc-safe-complementary__image" aria-label="${title}">${image ? `<img src="${image}" alt="" loading="lazy">` : ''}</a><div class="vc-safe-complementary__details"><a href="${product.url}" class="vc-safe-complementary__title">${title}</a><div class="vc-safe-complementary__price">${price}</div></div><div class="vc-safe-complementary__action">${action}</div></div>`;
  }

  money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(Number(cents) / 100); }
    catch (_) { return `€${(Number(cents) / 100).toFixed(2).replace('.', ',')}`; }
  }
  escape(value='') { return String(value).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])); }
}

if (!customElements.get('vc-safe-complementary')) customElements.define('vc-safe-complementary', VCSafeComplementary);
